import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Landing from "@/pages/Landing";
import QuoteFlow from "@/pages/QuoteFlow";
import CustomerQuote from "@/pages/CustomerQuote";
import DemoPage from "@/pages/DemoPage";
import Login from "@/pages/Login";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import Tarifs from "@/pages/Tarifs";
import DashboardLayout from "@/pages/dashboard/Layout";
import Overview from "@/pages/dashboard/Overview";
import Requests from "@/pages/dashboard/Requests";
import RequestDetail from "@/pages/dashboard/RequestDetail";
import Bookings from "@/pages/dashboard/Bookings";
import Services from "@/pages/dashboard/Services";
import Availability from "@/pages/dashboard/Availability";
import Branding from "@/pages/dashboard/Branding";
import Settings from "@/pages/dashboard/Settings";
import MtgLeads from "@/pages/dashboard/MtgLeads";
import Nenzio from "@/pages/dashboard/Nenzio";

function Protected({ children }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") return <div className="min-h-screen flex items-center justify-center text-slate-500">Chargement…</div>;
  if (status === "anon") return <Navigate to="/connexion" replace state={{ from: location.pathname + location.search }} />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/quote/:slug" element={<QuoteFlow />} />
            <Route path="/devis/:token" element={<CustomerQuote />} />
            <Route path="/connexion" element={<Login />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/tarifs" element={<Tarifs />} />
            <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
              <Route index element={<Overview />} />
              <Route path="demandes" element={<Requests />} />
              <Route path="demandes/:id" element={<RequestDetail />} />
              <Route path="reservations" element={<Bookings />} />
              <Route path="prestations" element={<Services />} />
              <Route path="disponibilites" element={<Availability />} />
              <Route path="apparence" element={<Branding />} />
              <Route path="parametres" element={<Settings />} />
              <Route path="prospects" element={<MtgLeads />} />
              <Route path="nenzio" element={<Nenzio />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
